import {Decimal} from 'decimal.js';
import {SymbolFormats} from './symbol-decimals';

interface FormatParams {
    decimalPlaces: number;
    precision: number;
}

export const getQtyFormatParams = (securityFormats: SymbolFormats): FormatParams => ({
    decimalPlaces: securityFormats.decimalPlaces.quantity,
    precision: securityFormats.precision.quantity
});

export const getPriceFormatParams = (securityFormats: SymbolFormats): FormatParams => ({
    decimalPlaces: securityFormats.decimalPlaces.price,
    precision: securityFormats.precision.price
});

export const getReportFormatParams = (securityFormats: SymbolFormats): FormatParams => ({
    decimalPlaces: securityFormats.decimalPlaces.report,
    precision: securityFormats.precision.report
});

export const symbolDecimalsFixValueFormat = (
    {decimalPlaces, precision}: FormatParams,
    origValue: number,
    rounding: Decimal.Rounding = Decimal.ROUND_HALF_DOWN
): number => {
    let correctValue: number = origValue;

    if (correctValue) {
        const dValue = new Decimal(origValue);

        correctValue = precision
            ? dValue.toSignificantDigits(precision, rounding).toNumber()
            : dValue.toDecimalPlaces(decimalPlaces, rounding).toNumber();
    }

    return correctValue;
};

export const fixValueFormatAsDecimal = (
    {decimalPlaces, precision}: FormatParams,
    dOrigValue: Decimal,
    rounding: Decimal.Rounding = Decimal.ROUND_HALF_DOWN
): Decimal => {
    let dValue: Decimal = dOrigValue;

    if (dValue) {
        dValue = precision
            ? dValue.toSignificantDigits(precision, rounding)
            : dValue.toDecimalPlaces(decimalPlaces, rounding);
    }

    return dValue;
};
